import { useState } from 'react';

interface ContactInfoData {
  company_email: string;
  company_phone: string;
  company_country_code: string;
  website?: string;
}

interface ContactInfoStepProps {
  initialData?: Partial<ContactInfoData>;
  onSubmit: (data: ContactInfoData) => void;
  onBack: () => void;
  isSubmitting?: boolean;
}

const inputClass =
  'w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent';
const labelClass = 'block text-sm font-medium text-gray-700 mb-1';

export const ContactInfoStep: React.FC<ContactInfoStepProps> = ({
  initialData,
  onSubmit,
  onBack,
  isSubmitting = false,
}) => {
  const [form, setForm] = useState<ContactInfoData>({
    company_email: initialData?.company_email ?? '',
    company_phone: initialData?.company_phone ?? '',
    company_country_code: initialData?.company_country_code ?? '52',
    website: initialData?.website ?? '',
  });

  const set = <K extends keyof ContactInfoData>(key: K, value: ContactInfoData[K]) =>
    setForm(prev => ({ ...prev, [key]: value }));

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(form);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="sm:col-span-2">
          <label htmlFor="companyEmail" className={labelClass}>
            Email empresarial *
          </label>
          <input
            className={inputClass}
            type="email"
            value={form.company_email}
            onChange={e => set('company_email', e.target.value)}
            required
          />
        </div>

        <div>
          <label htmlFor="companyCountryCode" className={labelClass}>
            Código de país *
          </label>
          <input
            className={inputClass}
            value={form.company_country_code}
            onChange={e => set('company_country_code', e.target.value)}
            placeholder="52"
            required
          />
        </div>

        <div>
          <label htmlFor="companyPhone" className={labelClass}>
            Teléfono empresarial *
          </label>
          <input
            className={inputClass}
            type="tel"
            value={form.company_phone}
            onChange={e => set('company_phone', e.target.value)}
            required
          />
        </div>

        <div className="sm:col-span-2">
          <label htmlFor="website" className={labelClass}>
            Sitio web (opcional)
          </label>
          <input
            className={inputClass}
            type="url"
            value={form.website ?? ''}
            onChange={e => set('website', e.target.value)}
            placeholder="https://"
          />
        </div>
      </div>

      <div className="flex justify-between pt-2">
        <button
          type="button"
          onClick={onBack}
          className="px-6 py-2 text-sm text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        >
          Anterior
        </button>
        <button
          type="submit"
          disabled={isSubmitting}
          className="px-6 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-60"
        >
          {isSubmitting ? 'Guardando...' : 'Siguiente'}
        </button>
      </div>
    </form>
  );
};
